import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

// Attach token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('inv_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Handle 401 + portal access-control denials (Items 3 & 4)
//
// Wave 3.99ad — Access denials now HARD-LOGOUT the user (wipe token, bounce to
// /login) instead of showing an in-app "try again" gate. The reason + the
// Super-Admin-authored message are stashed in sessionStorage so the Login page
// can render an explanatory banner. Super Admin never hits these branches
// (backend bypass).
function _hardLogout(reason, message) {
  try {
    if (reason) sessionStorage.setItem('inv_lockout_reason', reason);
    if (message) sessionStorage.setItem('inv_lockout_message', message);
  } catch { /* noop */ }
  try {
    localStorage.removeItem('inv_token');
    localStorage.removeItem('inv_user');
  } catch { /* noop */ }
  if (window.location.pathname !== '/login') {
    window.location.href = '/login';
  }
}

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err.response?.status;
    const headers = err.response?.headers || {};
    const detail = err.response?.data?.detail;
    const detailMsg = typeof detail === 'string' ? detail : '';
    // Portal Access Control: a 403 carrying one of these headers means the
    // user is currently locked out (global maintenance, global off-hours, or
    // their personal login schedule). Hard-logout so they must re-authenticate
    // once access is restored. On the login page itself we let the page show
    // the error inline (no redirect loop, no banner clobber).
    if (status === 403) {
      let reason = null;
      if (headers['x-portal-locked'] === '1') reason = 'locked';
      else if (headers['x-portal-offhours'] === '1') reason = 'offhours';
      else if (headers['x-user-offhours'] === '1') reason = 'user_offhours';
      if (reason && window.location.pathname !== '/login') {
        _hardLogout(reason, detailMsg);
        return Promise.reject(err);
      }
    }
    if (status === 401) {
      // Wave 3.99ad — Session hard-killed by an admin lockdown → show a banner.
      if (headers['x-session-ended'] === '1') {
        if (window.location.pathname !== '/login') {
          _hardLogout('session_ended', detailMsg);
        }
        return Promise.reject(err);
      }
      // Generic expired/invalid token — bounce to login (no banner).
      const path = window.location.pathname;
      if (path !== '/login') {
        localStorage.removeItem('inv_token');
        localStorage.removeItem('inv_user');
        window.location.href = '/login';
      }
    }
    return Promise.reject(err);
  }
);
